import { SiteDataInputType } from '../components/calculator/calculator.component';
import { ProductionType } from '../../services/analysis.service';

export class Util {
  static productionTypeFromSiteData(siteData: SiteDataInputType): ProductionType {
    switch (siteData) {
      case SiteDataInputType.NREL:
        return ProductionType.NREL;
      case SiteDataInputType.PVGIS:
        return ProductionType.PVGIS;
      case SiteDataInputType.PVSOL:
        return ProductionType.PVSOL;
      case SiteDataInputType.PVSYS:
        return ProductionType.PVSYS;
      default:
        return ProductionType.NREL;
    }
  }

  static b64toBlob(b64Data: string, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }
}
